export default [
    {
        path: 'parametrizacao',
        component: () => import(
            /* webpackChunkName: 'manutencao-parametrizacao' */
            '@/views/manutencao/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/index',
        children: [
            {
                name: 'manutencao-parametrizacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'manutencao-parametrizacao' */
                    '@/views/manutencao/parametrizacao/Form.vue'
                ),
            },
        ],
    },
]